import React from "react";
import "./styles.css";

const ModalResponseComponent = ({
  responseConfirmationAppointment,
  setShowFinalResponse,
}) => {
  const onClick = () => {
    setShowFinalResponse(false);
    window.location.href = "https://clinicaalejandria.es/";
  };

  return (
    <div className="modalBackgroundContainer">
      <div className="modalContainer">
        <h2 className="modalTitleContainer">Clínica Alejandría</h2>
        {responseConfirmationAppointment && (
          <div>
            <p className="messageConfirmation">
              {responseConfirmationAppointment.message}
            </p>
            <div className="containerButtonModalConfirm">
              <button className="buttonContainer" onClick={onClick}>
                ACEPTAR
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ModalResponseComponent;
